import { resolveAlias, selectEntity } from "state/selectors/data";
import { pageTypeToCmsType } from "cms/util";

export function selectSettingsId(store) {
    return resolveAlias(store, "cms.settings", "@websiteSettings");
}

const globalPageTypes = ["cms.pages"];

const defaultPageTypes = [
    "cms.entries.offers",
    "cms.entries.posts",
    "cms.entries.projects",
];

export function selectPageTypes(store) {
    const id = selectSettingsId(store);
    const settings = selectEntity(store, "cms.settings", id);
    const types = settings?.sitemap_entry_types || [];
    if (!types.length) return [...globalPageTypes, ...defaultPageTypes];
    return [...globalPageTypes, ...types.map(pageTypeToCmsType)];
}
